import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

const useStyles = makeStyles()((theme) => ({
	accoItem: {
		minWidth: theme.accoCard.width.sm,
		width: theme.accoCard.width.sm,
	},
	accoCardsListContainer: {
		gap: theme.spacing.small,
	},
}));

export default useStyles;
